import * as React from 'react';
import { Body1, Image, Label, UIHeading3 } from '@cian/ui-kit';

import grayStars from '../../../../../AiSummaryModalDesktop/assets/grayStarsLight.svg';
import type { IAiSummaryEmptyState, IAiSummaryNewbuilding } from '../../../../../AiSummaryModalDesktop/types';
import { NewbuildingCallToAction } from '../../../../../../containers/NewbuildingCallToAction';
import * as styles from './styles.css';
import clsx from 'clsx';

export interface INoDataBlockProps extends IAiSummaryEmptyState {
  isFullContent: boolean;
  newbuilding: Pick<IAiSummaryNewbuilding, 'builders' | 'fullUrl' | 'id' | 'sellers'>;
  onShowPhone?(): void;
}

export const NoDataBlock = ({
  title,
  subtitle,
  tags,
  isFullContent,
  newbuilding,
  onShowPhone,
}: INoDataBlockProps): React.JSX.Element => {
  const renderInteractiveLabel = (text: string, onClick: () => void) => (
    <Label
      background="accent-main-secondary"
      className={styles['interactive-label']}
      color="accent-main-primary"
      onClick={onClick}
    >
      {text}
    </Label>
  );

  return (
    <div className={clsx(styles['container'], isFullContent && styles['full-container'])}>
      <div className={styles['icon-wrapper']}>
        <Image height={24} src={grayStars} width={24} />
      </div>
      <div className={styles['text-wrapper']}>
        <div className={styles['heading-text-wrapper']}>
          <UIHeading3 textAlign="center">{title}</UIHeading3>
        </div>
        <Body1 textAlign="center">{subtitle}</Body1>
      </div>
      <div className={styles['labels-wrapper']}>
        <div className={styles['badge-container']}>
          {tags.map(tag => (
            <NewbuildingCallToAction
              builders={newbuilding.builders}
              fallbackTrigger={
                <Label background="accent-main-secondary" color="accent-main-primary">
                  {tag.text}
                </Label>
              }
              key={tag.text}
              newbuildingId={newbuilding.id}
              onShowPhone={onShowPhone}
              renderTrigger={onClick => renderInteractiveLabel(tag.text, onClick)}
              sellers={newbuilding.sellers}
              url={newbuilding.fullUrl}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
